import React, { useReducer, useEffect, useState } from "react";
import SectionHeader from "../../../components/SectionHeader/SectionHeader";
import MembershipDetailsForm from "../../Membership/Forms/MembershipDetailsForm/MembershipDetailsForm";
import MembershipProducts from "../../Membership/Forms/MembershipDetailsForm/MembershipProducts";
import AdditionalServices from "../../Membership/Forms/MembershipDetailsForm/AdditionalServices";
import LoadingOverlay from "react-loading-overlay";
import ErrorFooter from "../../../components/ErrorFooter/ErrorFooter";
import "../../../components/ErrorFooter/ErrorFooter.css";
import AdditionalServiceCard from "../../../components/AdditionalServiceCard/AdditionalServiceCard";
import EditAdditionalServiceModal from "../../../components/EditAdditionalServiceModal/EditAdditionalServiceModal";
import AddSpocModal from "../../../components/AddSpocModal/AddSpocModal";

import { MdModeEdit } from "react-icons/md";

import { useFormContext } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import {
  request,
  handleErrors,
  convertToInputDate,
  fakePromise,
} from "../../../services/helpers";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

// this component and all it's children assumes you are working with `react-hook-form`
// form library. Will crash without using the library.

const SET_FORM_LOADING = "SET_FORM_LOADING";
const FORM_DATA_SUCCESS = "FORM_DATA_SUCCESS";
const FORM_DATA_FAILURE = "FORM_DATA_FAILURE";
const FORM_SUBMIT_SUCCESS = "FORM_SUBMIT_SUCCESS";
const FORM_SUBMIT_FAILURE = "FORM_SUBMIT_FAILURE";
const SET_ADDITIONAL_SERVICE_MODAL = "SET_ADDITIONAL_SERVICE_MODAL";
const SET_UPDATE_SPOC_MODAL = "SET_UPDATE_SPOC_MODAL";
const SET_TERMIATION_MODAL = "SET_TERMINATION_MODAL";
const SET_UPDATE_MEMBERSHIP_MODAL = "SET_UPDATE_MEMBERSHIP_MODAL";

const UPDATE_ADDITIONAL_SERVICE_SUCCESS = "UPDATE_ADDITIONAL_SERVICE_SUCCESS";
const UPDATE_ADDITIONAL_SERVICE_FAILURE = "UPDATE_ADDITIONAL_SERVICE_FAILURE";

const UPDATE_SPOC_SUCCESS = "UPDATE_SPOC_SUCCESS";
const UPDATE_SPOC_FAILURE = "UPDATE_SPOC_FAILURE";

const SERVICE_TERMINATION_FAILURE = "SERVICE_TERMINATION_FAILURE";

const initialState = {
  additionalServicesToAdd: [],
  additionalServicesToEdit: [],
  currentAdditionalService: null,
  loading: false,
  formData: {},
  error: "",
  isAdditionalServiceModalVisible: false,
  isUpdateSpocModalVisible: false,
  isTerminationModalVisible: false,
  isUpdateMembershipModalVisible: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORM_LOADING:
      return {
        ...state,
        loading: action.payload === false ? action.payload : true,
        error: "",
        isAdditionalServiceModalVisible: false,
        isUpdateSpocModalVisible: false,
      };
    case FORM_DATA_SUCCESS: {
      return {
        ...state,
        formData: action.payload.formData,
        additionalServicesToEdit: action.payload.additionalServicesToEdit,
        additionalServicesToAdd: action.payload.additionalServicesToAdd,
        loading: false,
      };
    }

    case FORM_DATA_FAILURE: {
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    }

    case SET_ADDITIONAL_SERVICE_MODAL: {
      return {
        ...state,
        isAdditionalServiceModalVisible: action.payload.visible,
        currentAdditionalService: action.payload?.currentAdditionalService,
      };
    }

    case SET_UPDATE_SPOC_MODAL: {
      return {
        ...state,
        isUpdateSpocModalVisible: action.payload,
      };
    }

    case SET_TERMIATION_MODAL: {
      return {
        ...state,
        isTerminationModalVisible: action.payload,
      };
    }

    case SET_UPDATE_MEMBERSHIP_MODAL: {
      return {
        ...state,
        isUpdateMembershipModalVisible: action.payload,
      };
    }

    case UPDATE_ADDITIONAL_SERVICE_SUCCESS: {
      return {
        ...state,
        loading: false,
        additionalServicesToEdit: action.payload,
      };
    }

    case UPDATE_ADDITIONAL_SERVICE_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case UPDATE_SPOC_SUCCESS: {
      return {
        ...state,
        formData: {
          ...state.formData,
          billingInfo: {
            ...state.formData.billingInfo,
            ...action.payload,
          },
        },
        loading: false,
      };
    }

    case UPDATE_SPOC_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case FORM_SUBMIT_SUCCESS: {
      return {
        ...state,
        loading: false,
      };
    }

    case FORM_SUBMIT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case SERVICE_TERMINATION_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default:
      return state;
  }
};

const ViewMembership = () => {
  const { watch, handleSubmit, reset, setValue } = useFormContext();
  const [formState, dispatch] = useReducer(reducer, initialState);
  const [updateData, setUpdateData] = useState(null);

  const history = useHistory();
  const { membershipId } = useParams();
  const {
    error,
    loading,
    additionalServicesToAdd,
    additionalServicesToEdit,
    isAdditionalServiceModalVisible,
    currentAdditionalService,
    isUpdateSpocModalVisible,
    isTerminationModalVisible,
    isUpdateMembershipModalVisible,
    formData,
  } = formState;
  const membershipType = watch("type");

  useEffect(() => {
    let unmounted = false;
    (async () => {
      dispatch({ type: SET_FORM_LOADING });
      try {
        let res = await Promise.all([
          request.get(`/memberships?membershipId=${membershipId}`),
          request.get("/products/additionalService"),
        ]);
        const formData = res[0].data[0];
        const {
          name,
          type,
          endDate,
          lockingPeriod,
          // billingInfo,
          annualEscalation,
          startDate,
          // units,
          quantity,
          rate,
          meetingRoomCredits,
          securityDeposit,
          buildingDetails,
          onboardingCharges,
          exitCharges,
          totalNoOfDayPasses,
        } = formData;
        if (!unmounted) {
          reset({
            name,
            type,
            buildingId: buildingDetails.name,
            endDate: convertToInputDate(endDate),
            lockingPeriod: lockingPeriod || 0,
            annualEscalation: annualEscalation || 0,
            startDate: convertToInputDate(startDate),
            securityDeposit: securityDeposit || 0,
            rate: rate || 0,
            meetingRoomCredits: meetingRoomCredits || 0,
            workStationSeats: quantity?.workStationSeats || 0,
            meetingRoomSeats: quantity?.meetingRoomSeats || 0,
            collabAreaSeats: quantity?.collabAreaSeats || 0,
            onboardingCharges: onboardingCharges || 0,
            exitCharges: exitCharges || 0,
            totalDayPasses: totalNoOfDayPasses || 0,
          });

          dispatch({
            type: FORM_DATA_SUCCESS,
            payload: {
              formData: res[0].data[0],
              additionalServicesToEdit: res[0].data[0].additionalServices,
              additionalServicesToAdd: res[1].data,
            },
          });
        }
      } catch (e) {
        // console.log("error", e);
        dispatch({
          type: FORM_DATA_FAILURE,
          payload: handleErrors(e),
        });
      }
    })();
    return () => {
      unmounted = true;
    };
  }, [membershipId, reset, setValue]);

  const handleSubmitButton = (data) => {
    setUpdateData(data);
    dispatch({
      type: SET_UPDATE_MEMBERSHIP_MODAL,
      payload: true,
    });
  };

  const handleUpdateMembership = async (data) => {
    dispatch({
      type: SET_FORM_LOADING,
      payload: true,
    });
    dispatch({ type: SET_UPDATE_MEMBERSHIP_MODAL, payload: false });
    try {
      const {
        // rate,
        // buildingId,
        type,
        name,
        endDate,
        // startDate,
        // lockingPeriod,
        // annualEscalation,
        // securityDeposit,
        workStationSeats,
        additionalServices,
        meetingRoomSeats,
        collabAreaSeats,
        // onboardingCharges,
        // exitCharges,
        totalDayPasses,
        meetingRoomCredits,
      } = data;

      let quantity = {
        workStationSeats,
        meetingRoomSeats,
        collabAreaSeats,
      };

      let submitData = {
        name,
        // rate: rate || 0,
        // startDate,
        endDate,
        // lockingPeriod,
        // annualEscalation,
        // securityDeposit,
        // buildingId,
        type,
        meetingRoomCredits,
        additionalServices: additionalServices,
        quantity: quantity,
        // onboardingCharges,
        meetingRoomSeats: meetingRoomSeats || 0,
        collabAreaSeats: collabAreaSeats || 0,
        // exitCharges,
        membershipId,
        totalNoOfDayPasses: totalDayPasses,
      };
      await request.patch("/memberships", submitData);

      dispatch({
        type: FORM_SUBMIT_SUCCESS,
      });
      history.push({
        pathname: "/finish",
        state: {
          data: {
            title: "Membership Updated!",
            redirectTo: "/",
            completed: true,
            subTitle: "Membership Name",
            goTo: "go to dashboard",
            name,
          },
        },
      });
    } catch (e) {
      dispatch({
        type: FORM_SUBMIT_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  // Update Additional Service
  const handleUpdateAdditionalService = async (data) => {
    try {
      dispatch({
        type: SET_FORM_LOADING,
        payload: true,
      });

      const res = await request.patch(`/transactions/products`, {
        membershipId,
        product: data,
      });
      if (res.data && res.data.additionalServices) {
        dispatch({
          type: UPDATE_ADDITIONAL_SERVICE_SUCCESS,
          payload: res.data.additionalServices,
        });
      }
    } catch (e) {
      // console.log("errors", e, handleErrors(e));
      dispatch({
        type: UPDATE_ADDITIONAL_SERVICE_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  // Add a spoc
  const handleUpdateSpoc = async (data) => {
    try {
      dispatch({
        type: SET_FORM_LOADING,
        payload: true,
      });
      const res = await request.post("/memberships/spoc", {
        name: data.spocName,
        email: data.spocEmail,
        membershipId,
        updateSpoc: true,
      });
      dispatch({
        type: UPDATE_SPOC_SUCCESS,
        payload: { name: res.data.name, email: res.data.email },
      });
    } catch (e) {
      dispatch({
        type: UPDATE_SPOC_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  const handleServiceTermination = async (data) => {
    try {
      dispatch({ type: SET_ADDITIONAL_SERVICE_MODAL, payload: false });
      dispatch({ type: SET_FORM_LOADING });
      const res = await request.delete("/memberships/additionalService", {
        data: { membershipId: membershipId, id: data._id },
      });
      dispatch({ type: SET_FORM_LOADING, payload: false });

      dispatch({
        type: UPDATE_ADDITIONAL_SERVICE_SUCCESS,
        payload: res.data,
      });
    } catch (e) {
      dispatch({
        type: SERVICE_TERMINATION_FAILURE,
        payload: handleErrors(e),
      });
    }
  };

  const handleMembershipTermination = async () => {
    try {
      dispatch({ type: SET_TERMIATION_MODAL, payload: false });
      dispatch({ type: SET_FORM_LOADING });
      const res = await request.delete("/memberships", {
        data: { membershipId },
      });
      dispatch({ type: SET_FORM_LOADING, payload: false });
      history.push({
        pathname: "/finish",
        state: {
          data: {
            title: "Membership Deleted!",
            redirectTo: "/",
            completed: true,
            subTitle: "Membership Name",
            goTo: "go to dashboard",
            name: res.data.name,
          },
        },
      });
    } catch (e) {
      dispatch({
        type: SERVICE_TERMINATION_FAILURE,
        payload: handleErrors(e),
      });
    }
  };
  return (
    <div className="h-screen relative">
      <LoadingOverlay
        active={loading}
        spinner={loading}
        text="Loading please wait"
        // className="h-screen"
      >
        <div className="bg-formBackground">
          <SectionHeader
            path={["dashboard", "View Membership"]}
            title={"View Membership"}
          />
          <div className="fixed bottom-0 right-0">
            <button
              type="button"
              onClick={() =>
                dispatch({ type: SET_TERMIATION_MODAL, payload: true })
              }
              className="uppercase rounded p-2 shadow border-2 tracking-widest font-bold text-sm text-red-600 outline-none bg-white"
            >
              terminate membership
            </button>
          </div>
          <form onSubmit={handleSubmit(handleSubmitButton)} className="pb-24">
            {/* Membership Details Form */}

            <div className="lg:flex lg:px-32 px-8 lg:py-16 py-8">
              <div className="lg:mr-6 max-w-xs">
                <h4 className="font-medium text-2xl leading-7">
                  Membership Details
                </h4>
              </div>

              <div className="lg:mt-0 my-8 w-full">
                <MembershipDetailsForm
                  disabledFields={[
                    "buildingId",
                    "type",
                    "securityDeposit",
                    "onboardingCharges",
                    "lockingPeriod",
                    "annualEscalation",
                    "exitCharges",
                    "startDate",
                    "endDate",
                  ]}
                  loadLocations={false}
                  formData={formData}
                />
                {/* Products Section Form*/}
                <MembershipProducts
                  disabledFields={["rate"]}
                  membershipType={membershipType}
                />
                {/* EDIT SPOC SECTION */}
                <div className="mt-12">
                  <h2 className="font-medium text-2xl leading-7">
                    SPOC Details
                  </h2>
                </div>
                <div className="mt-8">
                  <button
                    type="button"
                    onClick={() =>
                      dispatch({ type: SET_UPDATE_SPOC_MODAL, payload: true })
                    }
                    className="flex justify-between items-center bg-white shadow-lg rounded p-4 md:w-1/2 w-full outline-none ease-in-out duration-500 transform hover:-translate-x-1 hover:scale-110 hover:bg-themeYellow"
                  >
                    <div className="flex flex-col items-start space-y-2">
                      <span className="text-xs font-bold tracking-normal">
                        SPOC
                      </span>
                      <span className="block text-base leading-3">
                        {formData.billingInfo?.name}
                      </span>
                    </div>
                    <div>
                      <MdModeEdit size={24} />
                    </div>
                  </button>
                </div>
                {/* SHOW ALREADY EXISTING ADDITIONAL SERVICES */}
                <div className="mt-12 max-w-xs">
                  <h2 className="font-medium text-2xl leading-7">
                    Existing Addtional Services
                  </h2>
                </div>
                <div className="lg:flex mt-8 max-w-full flex-wrap">
                  {additionalServicesToEdit.map((val, index) => (
                    <AdditionalServiceCard
                      key={val._id}
                      index={index}
                      service={val}
                      onEdit={() =>
                        dispatch({
                          type: SET_ADDITIONAL_SERVICE_MODAL,
                          payload: {
                            currentAdditionalService: val,
                            visible: true,
                          },
                        })
                      }
                    />
                  ))}
                </div>
                <hr className="border b-2 mb-8" />
                {/* Additional Services Form*/}
                {membershipType !== "2gethr Connect" && (
                  <AdditionalServices services={additionalServicesToAdd} />
                )}
              </div>
            </div>

            {error && (
              <div className="error-footer">
                <ErrorFooter message={error} />
              </div>
            )}
            <div className="shadow-lg flex flex-row-reverse py-4 px-8 border border-b-2 items-center">
              <button
                type="submit"
                className="bg-yellow-500 py-4 px-16 rounded font-bold text-sm tracking-widest leading-4 uppercase outline-none"
              >
                Submit
              </button>
            </div>
          </form>
        </div>

        {currentAdditionalService && (
          <EditAdditionalServiceModal
            handleTerminationClick={handleServiceTermination}
            onCancel={() =>
              dispatch({
                type: SET_ADDITIONAL_SERVICE_MODAL,
                payload: {
                  visible: false,
                },
              })
            }
            onSubmit={handleUpdateAdditionalService}
            service={currentAdditionalService}
            modalProps={{ open: isAdditionalServiceModalVisible }}
          />
        )}

        <AddSpocModal
          onCancel={() =>
            dispatch({ type: SET_UPDATE_SPOC_MODAL, payload: false })
          }
          onSubmit={handleUpdateSpoc}
          modalProps={{ open: isUpdateSpocModalVisible }}
          membershipName={formData.name}
        />
        {/* For Termination of membership */}
        <ConfirmationModal
          onCancel={() =>
            dispatch({ type: SET_TERMIATION_MODAL, payload: false })
          }
          onSubmit={handleMembershipTermination}
          title=" You're about to terminate a service."
          description="Membership invoicing & all other features will be suspended. You will NOT be able to undo this action"
          mode="terminate"
          modalProps={{ open: isTerminationModalVisible }}
        />
        {/* For updating membership */}
        <ConfirmationModal
          onCancel={() => {
            setUpdateData(null);
            dispatch({ type: SET_UPDATE_MEMBERSHIP_MODAL, payload: false });
          }}
          onSubmit={() => handleUpdateMembership(updateData)}
          title=" You’re about to update membership information."
          description="This will effect the invoicing amount from the coming month as per changes made. *Date of effective*"
          mode="update"
          modalProps={{ open: isUpdateMembershipModalVisible }}
        />
      </LoadingOverlay>
    </div>
  );
};

export default ViewMembership;
